// DEPENDENCIES
import format from 'date-fns/format';

// GLOBALS
import { DATE_FORMATS } from 'globals.js';

export default function DateTimeCell({ children, value = children, placeholder }) {
  return value && new Date(value) instanceof Date && !isNaN(new Date(value)) //
    ? format(new Date(value), DATE_FORMATS.shortDateTime)
    : placeholder;
}
